export const noop = () => {
};

export function selfFn<T>(it: T): T {
    return it;
}

export function idFn<V extends number | string, T extends {id: V}>(it: T): V {
    return it.id;
}

export function keyFn<V extends number | string, T extends {key: V}>(it: T): V {
    return it.key;
}

export function emptyArray<T>(): T[] {
    return [];
}

export function idEqFn<V1 extends {id: string | number}, V2 extends {id: string | number}>(v1: V1, v2: V2): boolean {
    return v1.id === v2.id;
}